import { AnalyticsTableConfig } from '@/models/analytics-table.interface'

export const topIntentsConfig: () => AnalyticsTableConfig = () => ({
  name: 'Top Intents',
  headerCells: ['intent', 'triggered', 'percentage of total'],
  columnSettings: [{ isStrong: true, sortType: 'string' }, { sortType: 'number' }, { isPercent: true }],
  paginationSettings: { perPage: 9 }
})

export const fabTopMerchants: () => AnalyticsTableConfig = () => ({
  name: 'Most shown offers',
  headerCells: ['Offer', 'Times Suggested'],
  columnSettings: [{ isStrong: true, sortType: 'string' }, { sortType: 'number' }],
  paginationSettings: { perPage: 5 }
})

export const fabTopOffersInteracted: (download: () => void) => AnalyticsTableConfig = (download) => ({
  name: 'Top Interacted Offers',
  headerCells: ['offer', 'interactions'],
  columnSettings: [{ isStrong: true, sortType: 'string' }, { sortType: 'number' }],
  paginationSettings: { perPage: 5 },
  download
})